import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import Portal from 'Components/frameworks/portal/Portal';
import { OVER_BOT } from 'Components/frameworks/portal/Portal.constants';
import { SpinnerLabel } from 'Components/frameworks/spinner/label/SpinnerLabel';
import { Spinner } from 'Components/frameworks/spinner/Spinner';
import { ICONS } from 'Components/utils/icon/icons';
import {
  getTopScrollValue,
  lockBodyScroll,
  resumeBodyScroll,
} from 'Components/utils/layers/stopScroll';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { usePrevious } from 'Src/hooks/use-previous/usePrevious';
import {
  getGlobalLoaderLabel,
  getIsNavigation,
  getShouldDisplayGlobalLoader,
} from 'Store/global-loader/storeHelper';

export const Loading = () => {
  const { isAppMounted } = useResponsive();
  const shouldDisplay = useSelector(getShouldDisplayGlobalLoader);
  const isNavigation = useSelector(getIsNavigation);
  const isPreviousNavigation = usePrevious(isNavigation);
  const previousShouldDisplay = usePrevious(shouldDisplay);
  const label = useSelector(getGlobalLoaderLabel);
  const [bodyScrollTop, setBodyScrollTop] = useState(0);

  useEffect(() => {
    if (shouldDisplay) {
      setBodyScrollTop(getTopScrollValue(document));
      lockBodyScroll(document);
    } else if (previousShouldDisplay) {
      // prevent removing the body locker when hydrate from server (there is no previousShouldDisplay)
      if (isPreviousNavigation) {
        // in case of navigation to another page we do not have to scroll to the last position
        resumeBodyScroll(document, 0);
      } else {
        resumeBodyScroll(document, bodyScrollTop);
      }
      setBodyScrollTop(0);
    }
  }, [shouldDisplay]);

  if (!isAppMounted || !shouldDisplay) {
    return null;
  }

  return (
    <Portal name={OVER_BOT}>
      <div
        className="fixed inset-0 z-4 flex flex-col items-center justify-center bg-white/90"
        id="loading"
      >
        <Spinner iconName={ICONS.TRIDENT1} />
        <SpinnerLabel label={label} />
      </div>
    </Portal>
  );
};
